import React, { useState } from "react";
import { Col, Row, Segmented, Typography } from "antd";
import { useParams } from "react-router-dom";
import { translate } from "../../locale";
import RangeForm from "../Charts/RangeForm";
import WaterCalendar from "../Calendar/WaterCalendar";

const { Title } = Typography;

const PatientWaterTable = () => {
  const [selectedSegment, setSelectedSegment] = useState("calendar");
  const { username } = useParams();

  const handleChangeItem = (value) => setSelectedSegment(value);

  return (
    <>
      <Row className="mt-6 mb-14" gutter={40}>
        <Col>
          <Segmented
            options={[
              { value: "calendar", label: "Calendario" },
              { value: "range", label: "Rangos" },
            ]}
            onChange={handleChangeItem}
          />
        </Col>
      </Row>
      <Row className="relative mb-14 w-full">
        {selectedSegment === "calendar" && <WaterCalendar />}
        {selectedSegment === "range" && (
          <RangeForm
            initialValues={{
              patient: username,
              type: "liters_of_water",
              max_value_alert: 5,
              max_value: 4,
              min_value: 2,
              min_value_alert: 1,
            }}
            title={translate("Carga de agua")}
          />
        )}
      </Row>
    </>
  );
};

export default PatientWaterTable;
